const SplineBackground = () => {
  return (
    <div className="fixed inset-0 w-full h-full overflow-hidden z-0">
      <iframe
        src="https://my.spline.design/orb-PKWGzKHSK50PTeQ2npFDWEtx/"
        frameBorder="0"
        width="100%"
        height="100%"
        className="w-full h-full"
        style={{
          pointerEvents: 'none',
          border: 'none',
        }}
        title="3D Background"
      />
      {/* Dark mode overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60 dark:block hidden"></div>
      {/* Light mode overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/60 to-white/70 dark:hidden"></div>
    </div>
  );
};

export default SplineBackground;
